/** Shopify CDN: Minification failed

Line 73:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 74:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 95:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 110:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 123:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 123:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 94:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 111:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 111:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 49:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 50:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 82:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 86:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 37:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 38:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 26:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 14:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 50:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:20 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
